<mat-form-field mat-select-height-large>
  <mat-label>{{ matchedValue?.translationid | translate }}</mat-label>
  <mat-select
    data-at-remote-diagnostics-edit-value="enum"
    gtm="onOpen"
    gtmAction="Open enum edit dropdown"
    gtmCategory="diagnosticsPage"
    [matTooltip]="matchedValue?.translationid | translate"
    (selectionChange)="onEnumOptionChange($event.value)"
    [value]="matchedValue?.value"
    fieldTextContentTooltip
  >
    <mat-option
      *ngFor="let enum of matchedValue?.structure"
      [value]="enum?.texttableentry"
      [attr.data-at-enum-edit-option]="enum?.texttableentry"
      gtm="onSelect"
      gtmAction="Enum: '{{ enum?.texttableentry }}'"
      gtmCategory="diagnosticsPageHeader"
      fieldTextContentTooltip
      >{{ enum?.TI_texttableentry | translate }}</mat-option
    >
  </mat-select>
</mat-form-field>
